<template>
  <div class="row mx-auto pb-2">
    <div class="col-12 py-2 px-0">
      <icon-view
        :has-border="false"
        icon="fas fa-file-plus color-orange"
        icon-size="1rem"
        title="Documentos"
        variant="custom-icon-view"
        icon-background="white"
      />
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 row px-0">
      <div class="col">
        <custom-drop-down
          v-model="documentType"
          :options="availableDocumentTypes"
          label="Tipo de Documento:"
          fieldkey="id"
          fieldname="name"
          placeholder="Seleccione"
          class="w-100  bold-label"
          :disabled="false"
        />
      </div>
      <div
        class="col-sm-3 col-md-3 col-lg-3 d-flex justify-content-between align-items-end"
      >
        <action-button
          id="btnAdd"
          i="fas fa-file-plus"
          text="Añadir"
          variant="success"
          :disabled="false"
          @click="handleAddDocumentType"
        />
      </div>
    </div>

    <div
      v-for="item in documentsDisplay"
      class="col-12 row mx-auto document-panel bg-white px-2 py-3 mt-3"
    >
      <div class="col-sm-12 col-md-4 data-col">
        <span class="color-gray-6 font-14">Tipo de Documento:</span>
        <span class="color-black font-14 font-weight-bold">
          {{ item.typeName | empty }}
        </span>
      </div>
      <div v-if="item.hasFile" class="col-sm-12 col-md-4 data-col">
        <span class="color-gray-6 font-14">Archivo:</span>
        <span class="color-black font-14 font-weight-bold">
          {{ item.fileName | empty }}
        </span>
      </div>
      <div
        v-else
        class="col-sm-12 col-md-4 d-flex align-items-center justify-content-end"
      >
        <custom-file-input
          v-model="item.file"
          :id="`document-${item.id}`"
          :ref="`ref-document-${item.id}`"
          display-style="normal"
          :accept="'.pdf'"
          @input="(file) => handleUploadFile(item.id, file)"
        />
      </div>
      <div
        class="col-sm-12 col-md-4 d-flex align-items-center justify-content-end"
      >
        <button
          v-if="item.hasFile"
          class="btn btn-success pt-1 mr-2"
          @click="handleDownloadFile(item.id)"
        >
          <i class="fas fa-file-download" />
        </button>
        <button
          class="btn btn-outline-danger px-2 pt-1 mr-2"
          @click="handleDeleteFile(item.id)"
        >
          <i class="fas fa-times-circle" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from '@/components/common/CustomFileInput';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'LazyDocuments',
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      documentType: null,
    };
  },
  computed: {
    documentsDisplay() {
      return this.documents.map((document) => ({
        id: document.id,
        typeName: document.type?.name,
        fileName: document.file?.name,
        hasFile: document.file !== null,
      }));
    },
    addedDocumentTypeIds() {
      return this.documents.map((document) => document.type.id);
    },
    availableDocumentTypes() {
      return this.documentTypes.filter(
        (t) => !this.addedDocumentTypeIds.includes(t.id)
      );
    },
  },
  methods: {
    handleAddDocumentType() {
      const exists = this.documents.some(
        (d) => d.type?.id === this.documentType?.id
      );
      if (exists || this.documentType === null) {
        this.documentType = null;
        return;
      }
      this.documents.push({
        id: `${Math.random()}`,
        type: this.documentType,
        file: null,
      });
      this.documentType = null;
    },
    handleUploadFile(id, file) {
      const index = this.documents.findIndex((document) => document.id === id);
      if (index !== -1) {
        this.documents[index].file = file;
      }
    },
    handleDownloadFile(id) {
      const index = this.documents.findIndex((document) => document.id === id);
      if (index !== -1) {
        const file = this.documents[index].file;
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
      }
    },
    async handleDeleteFile(id) {
      const result = await this.ShowCancelModal(
        'Alerta',
        '¿Está seguro que desea eliminar el documento?',
        'Sí',
        'No'
      );
      if (!result) return;
      const index = this.documents.findIndex((document) => document.id === id);
      if (index !== -1) {
        this.documents.splice(index, 1);
      }
    },
  },
  components: {
    IconView,
    ActionButton,
    CustomDropDown,
    CustomFileInput,
  },
  mixins: [alert],
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.data-col {
  display: flex;
  flex-direction: column;
}
.document-panel {
  border-left: 4px solid map-get($colors, 'gray-2');
}
.custom-icon-view {
  &:deep(.dot) {
    .title-icon {
      padding-top: 4px;
    }
  }
}
</style>
